export enum MobileMenu {
  tabs,
  orderTree,
  storeChooser,
  links,
}
